// Public image paths served from API
const BASE_UI = '/ui';
const BASE_PRODUCTS = '/api/images/products';

export const productImages: Record<string, string> = {
};


export const aboutImage = `${BASE_UI}/about/about-new.webp`;
export const heroImage = `${BASE_UI}/hero/hero-vineyard.webp`;
